import React from "react";
import "./PrivacyPolicy.css";
import Footer from "../components/Footer";

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <div className="bx-privacy-container">
        <h1 className="bx-privacy-title">Privacy Policy</h1>
        <p className="bx-privacy-updated">Last Updated: 11 / 02 / 2026</p>

        <h2 className="bx-privacy-heading">Introduction</h2>
        <p className="bx-privacy-text">
          This Privacy Policy explains how Bixton Distributors (Pvt) Ltd.
          ("Bixton", "we", "our", or "us"), a manufacturer, importer, and
          distributor of LED lighting and electrical products in Sri Lanka,
          collects, uses, stores, and protects personal information obtained
          through the Bixton website and related digital platforms.
        </p>

        <h2 className="bx-privacy-heading">1. Information We Collect</h2>

        <h3 className="bx-privacy-subheading">a) Inquiry & Contact Forms</h3>
        <p className="bx-privacy-text">
          When you contact us through our website or other digital channels, we
          may collect:
        </p>
        <ul className="bx-privacy-list">
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Company name (if applicable)</li>
          <li>Inquiry or message details</li>
        </ul>

        <h3 className="bx-privacy-subheading">b) Career Applications</h3>
        <ul className="bx-privacy-list">
          <li>Curriculum Vitae (CV)</li>
          <li>Personal and contact details</li>
          <li>Educational and professional background</li>
          <li>Employment history</li>
          <li>Any additional information voluntarily provided</li>
        </ul>

        <h3 className="bx-privacy-subheading">
          c) Automatically Collected Technical Information
        </h3>
        <ul className="bx-privacy-list">
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Device type and operating system</li>
          <li>Pages visited and time spent on the site</li>
          <li>Referral source</li>
        </ul>

        <h2 className="bx-privacy-heading">2. How We Use Your Information</h2>
        <ul className="bx-privacy-list">
          <li>Responding to inquiries</li>
          <li>Communicating with partners and customers</li>
          <li>Processing job applications</li>
          <li>Improving website experience</li>
          <li>Maintaining internal records</li>
          <li>Complying with legal requirements</li>
        </ul>

        <h2 className="bx-privacy-heading">3. Sharing and Disclosure</h2>
        <ul className="bx-privacy-list">
          <li>Authorized employees for recruitment/business purposes</li>
          <li>Trusted IT and hosting providers under confidentiality</li>
          <li>When required by law</li>
        </ul>

        <h2 className="bx-privacy-heading">
          4. Data Storage, Retention, and Security
        </h2>
        <p className="bx-privacy-text">
          We take reasonable technical and organizational measures to protect
          personal information.
        </p>

        <h2 className="bx-privacy-heading">5. Cookies and Analytics</h2>
        <ul className="bx-privacy-list">
          <li>Analyze traffic</li>
          <li>Measure performance</li>
          <li>Improve user experience</li>
        </ul>

        <h2 className="bx-privacy-heading">6. Your Rights</h2>
        <ul className="bx-privacy-list">
          <li>Access your personal data</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion</li>
          <li>Withdraw consent</li>
        </ul>

        <h2 className="bx-privacy-heading">7. Third-Party Links</h2>
        <p className="bx-privacy-text">
          Bixton is not responsible for the privacy practices of external sites.
        </p>

        <h2 className="bx-privacy-heading">8. Updates to This Policy</h2>
        <p className="bx-privacy-text">
          Updates will be posted on this page with a revised effective date.
        </p>

        <h2 className="bx-privacy-heading">9. Contact Information</h2>
        <address className="bx-privacy-address">
          Bixton Distributors (Pvt) Ltd.
          <br />
          Address: 305/47, Ferguson’s Road, Colombo 15, Sri Lanka
          <br />
          Email: sales@bixton.com
          <br />
          Website: www.bixton.com
        </address>

        <h2 className="bx-privacy-heading">10. Consent</h2>
        <p className="bx-privacy-text">
          By using this website, you acknowledge that you have read and agreed
          to this Privacy Policy.
        </p>
      </div>

      <section>
        <Footer />
      </section>
    </>
  );
};

export default PrivacyPolicy;
